import { WalletStateType } from 'types/reduxTypes/StateTypes';

export const defaultWalletState: WalletStateType = {
  wallet: {
    id: 0,
    startupID: 0,
    balance: '0',
    totalWalletAmount: '0',
    consumedAmount: '0',
    blockedAmount: '0',
  },
  budget: {
    blocked: 0,
    consumed: 0,
    total: 0,
    balance: 0,
  },
  walletTransactions: [],
  isLoading: false,
  count: 0,
  filters: {
    startups: [],
    cohorts: [],
    angelInvestors: [],
  },
  filtersActive: false,
}

export default null;
